(function () {
    'use strict';

    angular
        .module('blocks.filters')
        .filter('boolToYes', boolToYes);

    
    function boolToYes() {
        return function(input) {
            return input ? 'Yes' : '';
        }
    }

})();

